<div class="flex flex-column md:flex-row align-items-center justify-content-center bg-beige" style="min-height: 0; height: 100%;">
  <!-- Left: Image -->
  <div class="flex align-items-center justify-content-center p-3 md:p-5 w-full md:w-6">
    <img src="../../../assets/images/thank-you.png" alt="Thank you illustration" class="thank-you-img border-round-3xl shadow-2" style="max-width: 340px; max-height: 340px; width: 100%; height: auto; object-fit: contain; background: #f8f8f2;" />
  </div>
  <!-- Right: Thank You Message -->
  <div class="flex align-items-start justify-content-center flex-column gap-4 p-3 md:p-5 w-full md:w-6">
    <div class="flex align-items-center gap-3 mb-3">
      <span class="flex align-items-center justify-content-center">
        <app-lottie-animation 
          [animationPath]="'assets/animation/animation-optimized.json'"
          [width]="'72px'" 
          [height]="'72px'"
          [loop]="false">
        </app-lottie-animation>
      </span>
      <h1 class="thank-you-title m-0">Thank You!</h1>
    </div>
    <div>
      <p class="text-2xl md:text-2xl font-medium text-dark-blue mb-2">Thank you for contacting us!</p>
      <p class="text-lg text-color-secondary mb-0">We've received your message and will get back to you soon. Your inquiry is important to us.</p>
    </div>
  </div>
</div>
